import { formatDate, parseUtcDate } from './dateFormat';

/**
 * Shared period display for leave report rows.
 * Use when the row has either a periodDescription (e.g. "Oct 2025" for imported balance)
 * or a fromDate/toDate range (approved leave).
 */
export function getLeavePeriodDisplay(entry: {
  periodDescription?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
}): string {
  if (entry.periodDescription) return entry.periodDescription;
  if (entry.fromDate && entry.toDate) {
    const from = parseUtcDate(entry.fromDate);
    const to = parseUtcDate(entry.toDate);
    return `${formatDate(from, { format: 'medium' })} – ${formatDate(to, { format: 'medium' })}`;
  }
  return '—';
}
